var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessStake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#13CC95"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_356_456",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 48,
    height: 48
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_356_456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 50.9499C42.2567 50.9499 44.324 50.3331 46.202 49.0994C48.0804 47.8657 49.4174 46.1977 50.213 44.0954H29.787C30.616 46.1977 31.9614 47.8657 33.823 49.0994C35.6844 50.3331 37.7434 50.9499 40 50.9499ZM31.0435 37.6044L33.35 35.2979L35.6565 37.6044L37.711 35.5784L33.35 31.2454L29.0175 35.5784L31.0435 37.6044ZM44.3935 37.6044L46.7 35.2979L49.0065 37.6044L51.061 35.5784L46.7 31.2454L42.3675 35.5784L44.3935 37.6044ZM40.004 60.7064C37.1404 60.7064 34.4495 60.1672 31.9315 59.0889C29.4135 58.0109 27.2169 56.5341 25.3415 54.6584C23.4659 52.7831 21.989 50.5877 20.911 48.0724C19.8327 45.5567 19.2935 42.8672 19.2935 40.0039C19.2935 37.1402 19.8327 34.4494 20.911 31.9314C21.989 29.4134 23.4644 27.2162 25.337 25.3399C27.2094 23.4636 29.404 21.9819 31.921 20.8949C34.4377 19.8082 37.1285 19.2649 39.9935 19.2649C42.8589 19.2649 45.5517 19.8076 48.072 20.8929C50.5924 21.9782 52.79 23.4577 54.665 25.3314C56.5397 27.2054 58.02 29.4019 59.106 31.9209C60.192 34.4396 60.735 37.1326 60.735 39.9999C60.735 42.8659 60.1917 45.5579 59.105 48.0759C58.018 50.5936 56.5364 52.7889 54.66 54.6619C52.7837 56.5352 50.5879 58.0109 48.0725 59.0889C45.5569 60.1672 42.8674 60.7064 40.004 60.7064ZM40 56.7454C44.6704 56.7454 48.6289 55.1221 51.8755 51.8754C55.1222 48.6287 56.7455 44.6702 56.7455 39.9999C56.7455 35.3296 55.1222 31.3711 51.8755 28.1244C48.6289 24.8777 44.6704 23.2544 40 23.2544C35.3297 23.2544 31.3712 24.8777 28.1245 28.1244C24.8779 31.3711 23.2545 35.3296 23.2545 39.9999C23.2545 44.6702 24.8779 48.6287 28.1245 51.8754C31.3712 55.1221 35.3297 56.7454 40 56.7454Z",
    fill: "#141527"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessStake);
export default __webpack_public_path__ + "static/media/success-stake.e94edded764bf6826c2ad0b37ff087f1.svg";
export { ForwardRef as ReactComponent };